import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

export const STATUS_CONFIG = {
  queued: {
    label: 'Pendiente',
    Icon: AccessTimeIcon,
    color: '#5641c9',
    bg: '#eeeafd',
    border: '#d9d0fb',
  },
  sent: {
    label: 'Enviado',
    Icon: CheckIcon,
    color: '#1c8c54',
    bg: '#e6f7ee',
    border: '#bce8d1',
  },
  error: {
    label: 'Error al enviar',
    Icon: CloseIcon,
    color: '#cf3434',
    bg: '#fdecec',
    border: '#f6cdcd',
  },
}

export const HELP_TEXT = {
  queued: '(se enviará pronto)',
  error: null,
  sent: null,
}
